<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t('DOCUMENTS.ITEMS') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="indigo" outlined @click="dialogEdit = !dialogEdit">
        {{ $t('BUTTON.EDIT_DOCUMENTS') }}
      </v-btn>
    </v-toolbar>

    <v-data-table :headers="headers" :loading="!!!documents" :items="documents">
      <template v-slot:item.title="{ item }">
        <a target="_blank" :href="item.url" style="cursor: pointer;">{{
          item.title
        }}</a>
      </template>
    </v-data-table>

    <v-dialog
      v-if="dialogEdit"
      v-model="dialogEdit"
      persistent
      hide-overlay
      width="1200px"
    >
      <edit-documents-for-building
        :building="building"
        :documents-after-update="documents"
        @close="updateListOfDocuments"
      ></edit-documents-for-building>
    </v-dialog>
  </div>
</template>

<script>
import EditDocumentsForBuilding from '@/components/documents/EditDocumentsForBuilding';

export default {
  components: {
    EditDocumentsForBuilding
  },
  props: {
    building: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    documents: [],
    dialogEdit: false
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TITLE'),
          value: 'title'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type'
        }
      ];
    }
  },

  created() {
    this.refreshDocuments();
    // this.documents = this.building.uploads
  },

  methods: {
    updateListOfDocuments() {
      this.refreshDocuments();
      this.dialogEdit = !this.dialogEdit;
      this.$store.commit('snackbar/setSnack', {
        status: 'success',
        text: this.$t('MESSAGE.SUCCESS')
      });
    },

    refreshDocuments() {
      this.$store
        .dispatch('document/retrieveDocumentsForBuilding', this.building.id)
        .then(({ data }) => {
          this.documents = data.data;
        });
    }
  }
};
</script>
